import { TranslationResourceProvider } from 'Roblox';
import angular from 'angular';

let verifyEmail = angular
    .module("verifyEmail", ["robloxApp", "modal", "thumbnails"])
    .config(['languageResourceProvider', function (languageResourceProvider) {
        const translationProvider = new TranslationResourceProvider();
        const featureEmailConfirmationResources = translationProvider.getTranslationResource("Feature.EmailConfirmation");
        languageResourceProvider.setTranslationResources([featureEmailConfirmationResources]);
    }]);

export default verifyEmail;


